import {createContext,useContext,useMemo,useState,type ReactNode} from 'react'
export type AdminMode='simple'|'advanced'
const C=createContext<{mode:AdminMode;setMode:(mode:AdminMode)=>void}|null>(null)
export function AdminModeProvider({children}:{children:ReactNode}){
  const[mode,setModeState]=useState<AdminMode>(()=>localStorage.getItem('qcml-admin-mode')==='advanced'?'advanced':'simple')
  function setMode(next:AdminMode){setModeState(next);localStorage.setItem('qcml-admin-mode',next)}
  const value=useMemo(()=>({mode,setMode}),[mode])
  return <C.Provider value={value}>{children}</C.Provider>
}
export function useAdminMode(){const v=useContext(C);if(!v)throw new Error('AdminModeProvider required');return v}
